import { defineComponent as p, computed as d } from "vue";
import { processMediaItem as v } from "@i22/rocket";
import { getMainImageFromOffer as h } from "./td-longtail-vue-components89.js";
import I from "./td-longtail-vue-components8.js";
import W from "./td-longtail-vue-components9.js";
const F = /* @__PURE__ */ p({
  __name: "goliath-image-element",
  props: {
    imageClass: { default: void 0 },
    imageStyle: { default: void 0 },
    format: { default: void 0 },
    doNotConvert: { type: Boolean },
    preload: { type: Boolean },
    image: { default: void 0 },
    offer: { default: void 0 },
    alt: { default: void 0 },
    productName: { default: void 0 },
    xsWidth: { default: "medium" },
    smWidth: { default: "large" },
    lazy: { type: Boolean },
    imageIndex: { default: 0 },
    renderWithoutFigure: { type: Boolean },
    sizes: { default: void 0 }
  },
  emits: ["image-error"],
  setup(f, { expose: c }) {
    const e = f, m = (t, u) => {
      const r = {};
      return Object.keys(t).forEach((s) => {
        u.includes(s) || (r[s] = t[s]);
      }), r;
    }, i = (t) => {
      if (t)
        return t.replace(/\/public\//, "/product-images/");
    }, a = (t, u = "medium") => {
      let r = t;
      switch (t.mediaId && !t.medium && (r = v(t)), u) {
        case "small":
          return i(r.small);
        case "medium":
          return i(r.medium);
        default:
          return i(r.large);
      }
    }, g = d(() => m(e, [
      "offer",
      "src",
      "renderWithoutFigure",
      "image",
      "xsWidth",
      "smWidth"
    ])), o = d(() => {
      if (e.image) return e.image;
      if (e.offer) return h(e.offer, e.imageIndex);
    }), l = d(() => {
      if (o.value)
        return e.sizes ? a(o.value, "large") : a(o.value, e.xsWidth);
    }), n = d(() => {
      if (!(!o.value || e.sizes))
        return a(o.value, e.smWidth);
    });
    return c({
      src: l,
      srcSm: n
    }), { __sfc: !0, getFiltersProps: m, getUrl: i, getImagesByWidth: a, props: e, passThroughProps: g, parsedImage: o, src: l, srcSm: n, ImageElement: I, PictureElement: W };
  }
});
export {
  F as default
};
